import React, { useEffect, useState } from 'react';
import TopBanner from '../TopBanner/TopBanner';
import Leagues from '../Leagues/Leagues';
import './Home.css';

const Home = () => {
    const [leagues, setLeagues] = useState([]);
    useEffect(() => {
        const allLeaguesUrl = "https://www.thesportsdb.com/api/v1/json/1/all_leagues.php";
        fetch(allLeaguesUrl)
            .then(response => response.json())
            .then(data => setLeagues(data.leagues.slice(0, 21)))
    }, []);

    return (
        <div>
            <TopBanner />
            <main className="all-leagues container">
                {
                    leagues.map(league => <Leagues key={league.idLeague} league={league}></Leagues>)
                }
            </main>
        </div>
    );
};

export default Home;